import React, { useState } from 'react';
import { useLocation , useNavigate } from 'react-router-dom-v5-compat';
import { checkValue, getLocalStorageList, ItemKeyHelper, onImageLoadWithoutCache } from 'src/components/common/helper';
import Layout from 'src/components/common/theme/Layout';
import {
  PrimaryButton,
  PrimaryButtonProps,
  SecondaryButton,
  SecondaryButtonProps,
} from 'src/components/common/ui/button/button';
import { conciergeBaseUrl, conciergeWishlistCount } from 'src/components/concierge/util/helper';
import * as config from 'src/config/config';
import { useStores } from 'src/utils/useStore';
import { css } from 'styled-components';
import { UitkButtonSize } from 'uitk-react-button';
import { UitkText } from 'uitk-react-text';
import { HeaderBrandLogo, HeaderBrandLogoProps } from '../../header-brand-logo/brand-logo';
import { Icon, IconProps } from '../../icon/icon';
import { SubHeaderProps } from '../global-header.d';
import gaLogger from 'src/utils/ga-logger';
import { getTranslateLoc } from 'src/components/concierge/util/helper';
import LozengeMessageV2 from 'src/components/common/modules/global-header/lozenge-message/lozenge-message-v2';
import { LozengeMessageV2Props } from 'src/components/common/module-util';

const localStorageKey = config.config.meso_concierge.localStorageKey;
let isBookNowButtonClick = false;
//@todo = get these valuse in line 29 as props from passing down from the parent
const PartnerSubHeader: React.FC<SubHeaderProps> = (props) => {
  const {
    cpcmslitefeed: {
      conciergePageData: {
        data: { itinerary, primaryColor,conciergeLocalization},
      },
    },
  } = useStores();
 
  const [toggle, setToggle] = useState(false);
  const [toggleDesktop, setToggleDesktop] = useState(false);

  const keyHelper = new ItemKeyHelper('partnerSubHeader-itineraryMenuItem');
  const baseUrl = conciergeBaseUrl();
  let wishCount = conciergeWishlistCount();
  const locFeedType = conciergeLocalization;
  const location = useLocation();
  const navigate = useNavigate();
  const urlPaths = location?.pathname?.split('/');
  const pageLink = checkValue(urlPaths, true) ? urlPaths?.[urlPaths.length - 1] : '';
  const headermoredropdownIconProps: IconProps = {
    icon: {
      iconPath: onImageLoadWithoutCache('https://mesocp3.azureedge.net/media/5h3lftok/dropdown-think.svg'),
      color: '#ffffff',
    },
    background: {
      bgShape: undefined,
      bgHeight: 12,
      bgWidth: 12,
    },
  };

  const goToPage = (pageUrl: string) => {
    let storedWishList: string;
    let pushPageUrl = `${pageUrl}`;

    if (checkValue(JSON.parse(getLocalStorageList(localStorageKey)))) {
      storedWishList = JSON.parse(getLocalStorageList(localStorageKey));

      if (pageUrl.indexOf('wish-list') > -1) {
        pushPageUrl += pushPageUrl.indexOf('?') > -1 ? '&ids=' + storedWishList : '?ids=' + storedWishList;
        navigate(pushPageUrl);
      } else {
        navigate(pushPageUrl);
      }
    } else {
      wishCount = '';
      storedWishList = '';
      navigate(pushPageUrl);
    }

    setTimeout(() => {
      window.scrollTo({
        behavior: 'smooth',
        top: 0,
      });
    }, 100);
  };

  const headerBrandLogoProps: HeaderBrandLogoProps = {
    altText: props?.partnerLogoAltText,
    imgSrc: props?.partnerLogo,
    href: props?.partnerUrl,
    title: props?.partnerName,
    areaLabel: props?.partnerLogoAltText,
    areaLableBy: '',
    exClass: `partner-logo ${props?.partnerHeaderSize}`,
    gaTracking: {
      eventCategory: 'Partner Sub Header',
      eventAction: 'Partner Logo Click',
      eventLabel: props?.partnerUrl,
    },
    target: props?.openPartnerUrlInSameTab ? '_self' : '_blank',
  };

  const wishListButtonProps: PrimaryButtonProps = {
    tag: 'a',
    text: wishCount
     ? `${getTranslateLoc(locFeedType, 'ctaTitle', 'My wishlist (#number#)').replace('#number#', wishCount)}`
     : `${getTranslateLoc(locFeedType, 'ctaTitle', 'My wishlist').replace('(#number#)', '')}`,
   
    gaTracking: { eventAction: 'my_wishlist_clicked', eventCategory: 'header_wishlist', eventLabel: 'my_wishlist' },
    expTracking: undefined,
    exClass: `partner-menu-item heading con-btn headerWLCTA ${pageLink === 'wish-list' ? 'url-active' : ''}`,
    onClickEvent: (e) => {
      const menuActive = document.querySelectorAll('.partner-header-item-container span.active');
      menuActive.forEach((item) => item.classList.remove('active'));
      e.target.classList.add('active');
      setToggle(false);
      return goToPage(`${baseUrl}/wish-list`);
    },
  };

  const secondaryButtonProps: SecondaryButtonProps = {
    text: props?.partnerCtaText,
    tag: 'a',
    gaTracking: {
      eventCategory: 'Partner Header CTA URL',
      eventAction: 'Partner ' + props?.partnerCtaUrl + ' Click',
      eventLabel: props?.partnerCtaText,
    },
    exClass: `partner-header-action ga4-partner-header-shop-btn`,
    ...(checkValue(props?.partnerCtaUrl) ? {url: props?.partnerCtaUrl} : {}),
    target: '_blank',
    size: UitkButtonSize.LARGE,
    onClickEvent: () => {
      if (!checkValue(props?.partnerCtaUrl)) {
        const wizardContainer = document.querySelector<HTMLElement>('.booking-section');
        if (checkValue(wizardContainer)) {
          const headerElement = document.querySelector<HTMLElement>('.header-main-container');
          const headerOffsetHeight = checkValue(headerElement) ? headerElement?.offsetHeight : 0;

          const initWizardTop =
            wizardContainer.getBoundingClientRect().top -
            document.body.getBoundingClientRect().top -
            headerOffsetHeight;
          window.scrollTo({
            behavior: 'smooth',
            top: initWizardTop,
          });

          //This need to first time since lazy images/ video not loaded with the scroll
          if (!isBookNowButtonClick) {
            setTimeout(() => {
              const reCalWizardTop =
                wizardContainer.getBoundingClientRect().top -
                document.body.getBoundingClientRect().top -
                headerOffsetHeight;
              window.scrollTo({
                behavior: 'smooth',
                top: reCalWizardTop,
              });
              isBookNowButtonClick = true;
            }, 800);
          }
        }
      }
    },
  };

  const menuToggle = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    setToggle(!toggle);
  };

  const menuDesktopToggle = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    setToggle(false);
    setToggleDesktop(!toggleDesktop);
  };

  const deskTopItineraryMenus = [];
  const mobileItineraryMenus = [];

  const itineraryMenuItem = async () => {
    if (checkValue(itinerary, true)) {
      itinerary.map((itin: any, i: number) => {
        const { itineraryName, itineraryUrl } = itin;
        const isPageActive = pageLink === itineraryUrl.replace('/', '');

        if (checkValue(itineraryName) && checkValue(itineraryUrl) && deskTopItineraryMenus.length < 3) {
          const itineraryButtonProps: PrimaryButtonProps = {
            tag: 'a',
            text: itineraryName,
            gaTracking: {
              eventAction: 'link_cliked_' + itineraryName,
              eventCategory: 'header_itinerary',
              eventLabel: itineraryName,
            },
            expTracking: undefined,
            exClass: `partner-menu-item heading con-btn ${isPageActive ? 'url-active' : ''}`,
            onClickEvent: (e) => {
              const menuActive = document.querySelectorAll('.partner-header-item-container span.active');
              menuActive.forEach((item) => item.classList.remove('active'));
              e.target.classList.add('active');
              setToggle(false);
              return goToPage(`${baseUrl}${itineraryUrl.indexOf('/') > -1 ? itineraryUrl : '/' + itineraryUrl}`);
            },
          };

          deskTopItineraryMenus.push(<PrimaryButton {...itineraryButtonProps} />);
          mobileItineraryMenus.push(
            <li key={keyHelper.next()} className="nav-item">
              <PrimaryButton key={i} {...itineraryButtonProps} />
            </li>
          );
        }
      });
    }
    return null;
  };

  itineraryMenuItem();


  const logoOnclick = () => {
    const { gaTracking, href, target } = headerBrandLogoProps;
    const { eventCategory, eventAction, eventLabel } = gaTracking;
    gaLogger.logGa(eventCategory, eventAction, eventLabel);

    if (href) {
      if (target === '') {
        window.location.href = href;
      } else {
        window.open(href, target);
      }
    }else{
      goToPage(`${baseUrl}`);
    }
  };

  const moduleCss = () => {
    return `
      ${
        checkValue(props?.partnerHeaderBackgroundColor)
          ? `
            &.partner-sub-header {
              background-color: ${props?.partnerHeaderBackgroundColor} !important;
            }
            .partner-header-item-container .partner-menu-item {
              background-color: ${props?.partnerHeaderBackgroundColor} !important;
            }
            .partner-header-item-container .partner-menu .desktop-nav li a:hover {
              background-color: ${props?.partnerHeaderBackgroundColor} !important;
            }
          `
          : ''
      }
      ${
        checkValue(props?.partnerHeaderTextColor)
          ? `
            &.partner-sub-header {
              color:${props?.partnerHeaderTextColor?.toLowerCase() === 'dark' ? '#141D38' : '#ffffff'} !important;
            }
          `
          : ''
      }
      .partner-header {
        .partner-menu {
          a.url-active > span,
          .desktop-nav-dropdown:hover {
            color: ${primaryColor} !important;
            border-bottom: 5px solid  ${primaryColor} !important;
            .svg-icon {
              background-color: ${primaryColor} !important; 
            }
          }
        }
        ${
          checkValue(props?.partnerCtaColor)
          ? `
            .partner-header-item-container .partner-header-action {
              background-color: ${props?.partnerCtaColor};
              border-color: ${props?.partnerCtaColor};
              &:hover {
                background-color: ${props?.partnerCtaColor} !important;
                color: inherit !important;
                filter: brightness(0.8);
              }
            }
          `
          : ''
        }
      }
    `;
  };

  const lozengeMessageProps: LozengeMessageV2Props = {
    lozengeDetailMessage: props?.lozengeDetailMessage,
    backgroundColor: checkValue(props?.lozengeBackgroundColor) ? props?.lozengeBackgroundColor : props?.partnerHeaderBackgroundColor,
    color: props?.lozengeTextColor,
    defaultTextColor: props?.partnerHeaderTextColor,
    exClass: !checkValue(props?.partnerLogo) && !checkValue(props?.partnerName) ? 'left-margin-0' : '',
    iconStyle: props?.lozengeIconStyle,
    iconColor: props?.lozengeIconColor,
  };

  return (
    <Layout
      HtmlTag="div"
      className="partner-sub-header"
      css={css`
        ${moduleCss()}
      `}     
    >
      <div className="partner-header">
        <div className="partner-header-container" onClick={()=> logoOnclick()}>
          {checkValue(props?.partnerLogo) && (
            <HeaderBrandLogo {...{ ...headerBrandLogoProps, gaTracking: undefined, href: false }} />
          )}
          {checkValue(props?.partnerName) && (
            <UitkText className={`partner-name ${!checkValue(props?.partnerLogo) ? 'no-margin' : ''}`}>
              {props?.partnerName}
            </UitkText>
          )}
          <LozengeMessageV2 {...lozengeMessageProps} />
        </div>
        <div className="partner-header-item-container">
          <div className="partner-menu desktop">
            <PrimaryButton {...wishListButtonProps} />
            {deskTopItineraryMenus}
            {deskTopItineraryMenus.length > 2 && (
              <div className="more-dropdown">
                <a
                  className={`desktop-nav-dropdown  ${toggleDesktop ? 'show-menu' : 'hide-menu'}`}
                  onClick={menuDesktopToggle}
                >
                  More
                  <span>
                    <div className="logo">
                      <Icon {...headermoredropdownIconProps} />
                    </div>
                  </span>
                </a>
                <ul className={`desktop-nav ${toggleDesktop ? 'show' : 'hide'}`} onClick={menuDesktopToggle}>
                  <li className="nav-item">
                    <PrimaryButton {...wishListButtonProps} />
                  </li>
                  {mobileItineraryMenus}
                </ul>
              </div>
            )}
          </div>
          {checkValue(props?.partnerCtaText) && <SecondaryButton {...secondaryButtonProps} />}
          <div className="partner-mobile-menu mobile">
            <a href={void 0} className={`menu-icon ${toggle ? 'hide-menu' : 'show-menu'}`} onClick={menuToggle}>
              <div></div>
            </a>
          </div>
        </div>
      </div>
      <ul className={`mobile-nav ${toggle ? 'show' : 'hide'}`}>
        <li className="nav-item">
          <PrimaryButton {...wishListButtonProps} />
        </li>
        {mobileItineraryMenus}
      </ul>
    </Layout>
  );
};

export default PartnerSubHeader;
